export default "__VITE_ASSET__2b57f26d__"